import Footer from '@/components/modules/Footer/Index';
import Header from '@/components/modules/Header/Index';
import { Box } from '@chakra-ui/react';
import { DefaultSeo } from 'next-seo';
import React from 'react';
import { useTranslation } from 'next-i18next';

type Props = {
  children?: React.ReactNode;
};

const DefaultTemplate = ({ children }: Props) => {
  const { t } = useTranslation(`common`);
  return (
    <>
      <DefaultSeo
        defaultTitle={t(`default_seo.page_name`)}
        titleTemplate={t(`default_seo.page_name_template`)}
        description={t(`default_seo.description`)}
        additionalMetaTags={[
          {
            name: `viewport`,
            content: `width=device-width, initial-scale=1.0, viewport-fit=cover, maximum-scale=5`,
          },
        ]}
        additionalLinkTags={[
          {
            rel: `icon`,
            href: `/favicon.ico`,
          },
          {
            rel: `icon`,
            type: `image/png`,
            href: `/icon.png`,
          },
          {
            rel: `apple-touch-icon`,
            href: `/apple-touch-icon.png`,
          },
          {
            rel: `apple-touch-icon`,
            href: `/apple-touch-icon-57x57.png`,
            sizes: `57x57`,
          },
          {
            rel: `apple-touch-icon`,
            href: `/apple-touch-icon-72x72.png`,
            sizes: `72x72`,
          },
          {
            rel: `apple-touch-icon`,
            href: `/apple-touch-icon-76x76.png`,
            sizes: `76x76`,
          },
          {
            rel: `apple-touch-icon`,
            href: `/apple-touch-icon-114x114.png`,
            sizes: `114x114`,
          },
          {
            rel: `apple-touch-icon`,
            href: `/apple-touch-icon-120x120.png`,
            sizes: `120x120`,
          },
          {
            rel: `apple-touch-icon`,
            href: `/apple-touch-icon-144x144.png`,
            sizes: `144x144`,
          },
          {
            rel: `apple-touch-icon`,
            href: `/apple-touch-icon-152x152.png`,
            sizes: `152x152`,
          },
          {
            rel: `apple-touch-icon`,
            href: `/apple-touch-icon-180x180.png`,
            sizes: `180x180`,
          },
        ]}
        openGraph={{
          type: `website`,
          locale: `tr_TR`,
          url: `https://www.voltranapp.com/`,
          site_name: t(`default_seo.og_site_name`),
          title: t(`default_seo.og_title`),
          description: t(`default_seo.og_description`),
          images: [
            {
              url: `/images/banner.jpg`,
              alt: `voltran`,
              height: 324,
              width: 576,
            },
          ],
        }}
        twitter={{
          handle: `@AppVoltran`,
          site: `@AppVoltran`,
          cardType: `summary_large_image`,
        }}
        languageAlternates={[
          {
            hrefLang: `en`,
            href: `https://www.voltranapp.com/en/`,
          },
          {
            hrefLang: `tr`,
            href: `https://www.voltranapp.com/`,
          },
        ]}
      />
      <Box as="main" pt="8">
        <Header />
        {children}
        <Footer />
      </Box>
    </>
  );
};

export default DefaultTemplate;
